import {
    HttpResponse,
    ProductModel,
    QueryModel,
    RequestParams,
    ProductModelIEnumerableApiResultSuccess,
    ProductModelApiResultSuccess,
    ApiResultFailed,
    Operation,
    FullRequestParams,
    AggregationModel,
    AggregationResponse,
    GrouppedQueryModel
} from "@/libs/Api";
import ApiService from "@/libs/core/api-service"
import {CrudDataQuery} from '@/libs/core/crud/crud-query';
import {CrudService, CrudListResponse, CrudResponse} from '@/libs/core/crud/crud-service';

export class ProductsDataService implements CrudService<ProductModel, ProductModel> {
    
    getAggregation(query: AggregationModel, params?: RequestParams): Promise<AggregationResponse> {
        throw new Error("Method not implemented.");
    }
    
    getGrouped(query: GrouppedQueryModel, params?: RequestParams): Promise<CrudResponse<any>> {
        throw new Error("Method not implemented.");
    }
    
    getAll(query: CrudDataQuery<ProductModel>): Promise<CrudListResponse<ProductModel>> {
        return ApiService.api.getProductBatch(query.pageIndex, query.pageSize, <any>query.data, query.params);
    }

    get(id: string, params?: RequestParams): Promise<CrudResponse<ProductModel>> {
        return ApiService.api.getProductById(id, params);
    }

    create(item: ProductModel, params?: RequestParams): Promise<CrudResponse<ProductModel>> {
        return ApiService.api.insertProduct(item, params);
    }

    update(item: ProductModel, params?: RequestParams): Promise<ProductModel> {
        return ApiService.api.updateProduct(item.id as Required<string>, item, params).then((req: any) => req.data.returnValue);
    }

    partialUpdate(id: string, patches: Operation[], params?: RequestParams): Promise<ProductModel> {
        return ApiService.api.patchProduct(id, patches).then((req: any) => req.data.returnValue);
    }

    delete(query: CrudDataQuery<ProductModel>): Promise<CrudListResponse<ProductModel>> {
        return ApiService.api.deleteProducts(<any>query.data, query.params).then((req: any) => req.data.returnValue);
    }

    download(query: CrudDataQuery<ProductModel>): Promise<HttpResponse<any, ApiResultFailed | void>> {
        throw "NotImplemented";
    }

}
